<template>
    <div class="hisSubordinate">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="头像/昵称">
                <template slot-scope="scope">
                    <div class="imgName">
                        <div class="imgBox">
                            <img :src="scope.row.headimageurl" alt="">
                        </div>
                        <span>{{scope.row.name}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="mobileno" label="手机号" class-name="center"></el-table-column>
            <el-table-column prop="totalordermoney" label="直接消费金额" class-name="center"></el-table-column>
            <el-table-column prop="totalordercount" label="直接消费笔数" class-name="center"></el-table-column>
            <el-table-column prop="datetime" label="最新绑定时间" class-name="center"></el-table-column>
        </el-table>
        <Page ref="page" :total="total"></Page>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import Page from '@/base/page/page'
import {subordinateList} from '@/api/extensionAgent'
export default {
    name: 'hisSubordinate',
    props: ['innerid'],
    data() {
        return {
            total: 0,
            tableData: [],
            params: {
                innerid: ''
            }
        }
    },
    methods: {
        getSubordinateList() {
            this.setLoading(true)
            subordinateList({
                data: Object.assign({}, this.params, this.$refs.page.page),
                success: data => {
                    this.total = data.pageableData.rowCount
                    this.tableData = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'innerid': {
            handler(newV) {
                if (newV) {
                    this.params.innerid = newV
                    this.getSubordinateList()
                }
            }
        }
    },
    components: {
        Page
    }
}
</script>
<style lang="scss">
    .hisSubordinate{
        .el-table{
            .imgName{
                display: flex;
                align-items: center;
                .imgBox{
                    width: 50px;
                    height: 50px;
                    margin-right: 6px;
                    img{
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                    }
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
        }
    }
</style>